/**
 * @function
 * @description reInitializes the Back to Top button
 */
var coreScrollToTop = require('_core_ext/components/search/scrolltotop');

coreScrollToTop.createButton = function () {
    var button = $('<div/>',{
        'id': 'scrollToTop',
        'role': 'button',
        'tabindex': '0',
        'class': 'scroll-to-top',
        'aria-label': 'Back to top',
        'text': ''
    });

    button.on('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ' || e.keyCode === 13 || e.keyCode === 32) {
            e.preventDefault();
            $(this).trigger('click');
        }
    });

    $('body').append(button);

    return button;
};

exports = coreScrollToTop;
